<script lang="ts">
  import { Tesoreria, type CuentaBancaria, type TransaccionBancaria, type Cheque } from '../lib/api';

  let cuentas = $state<CuentaBancaria[]>([]);
  let cuentaSel = $state<string>('');
  let transacciones = $state<TransaccionBancaria[]>([]);
  let cheques = $state<Cheque[]>([]);
  let error = $state<string|null>(null);

  let nuevaCta = $state<CuentaBancaria>({ banco:'', numero:'', alias:'', tipo:'MONETARIA', moneda:'GTQ', activa:true });
  let nuevaTx = $state<TransaccionBancaria>({ cuentaId:'', tipo:'DEPOSITO', monto:0, referencia:'', concepto:'' });
  let nuevoChq = $state<Cheque>({ cuentaId:'', numero:'', beneficiario:'', monto:0, concepto:'' });

  async function cargar() {
    try {
      cuentas = await Tesoreria.cuentas();
      cheques = await Tesoreria.cheques();
      if (cuentaSel) transacciones = await Tesoreria.transac(cuentaSel);
    } catch (e: any) { error = e?.message ?? String(e); }
  }

  async function crearCta(e: SubmitEvent) { e.preventDefault();
    try { await Tesoreria.crearCta({ ...nuevaCta }); nuevaCta = { banco:'', numero:'', alias:'', tipo:'MONETARIA', moneda:'GTQ', activa:true }; await cargar(); } catch (e:any) { error = e?.message; }
  }
  async function crearTx(e: SubmitEvent) { e.preventDefault();
    try { await Tesoreria.crearTx({ ...nuevaTx, cuentaId: cuentaSel }); nuevaTx = { cuentaId:'', tipo:'DEPOSITO', monto:0, referencia:'', concepto:'' }; await cargar(); } catch (e:any) { error = e?.message; }
  }
  async function emitirCheque(e: SubmitEvent) { e.preventDefault();
    try { await Tesoreria.emitir({ ...nuevoChq, cuentaId: cuentaSel }); nuevoChq = { cuentaId:'', numero:'', beneficiario:'', monto:0, concepto:'' }; await cargar(); } catch (e:any) { error = e?.message; }
  }
  async function conciliar(id: string) { try { await Tesoreria.conciliar(id); await cargar(); } catch (e:any) { error = e?.message; } }
  async function cobrarCh(id: string)  { try { await Tesoreria.cobrarChq(id); await cargar(); } catch (e:any) { error = e?.message; } }

  $effect(() => { cargar(); });
  $effect(() => { if (cuentaSel) Tesoreria.transac(cuentaSel).then(t => transacciones = t).catch(e => error = e?.message); });
</script>

<section>
  <header><h2>Tesorería &middot; Bancos &middot; Cheques</h2><button onclick={cargar}>Recargar</button></header>
  {#if error}<p class="err">⚠ {error}</p>{/if}

  <h3>Cuentas bancarias</h3>
  <form onsubmit={crearCta} class="row">
    <input placeholder="Banco" bind:value={nuevaCta.banco} required/>
    <input placeholder="Número" bind:value={nuevaCta.numero} required/>
    <input placeholder="Alias" bind:value={nuevaCta.alias}/>
    <select bind:value={nuevaCta.tipo}><option>MONETARIA</option><option>AHORRO</option><option>PLAZO</option></select>
    <button type="submit">Agregar</button>
  </form>
  <table>
    <thead><tr><th>Banco</th><th>Número</th><th>Alias</th><th>Tipo</th><th>Saldo</th><th></th></tr></thead>
    <tbody>
      {#each cuentas as c (c.id)}
        <tr class:sel={c.id===cuentaSel}>
          <td>{c.banco}</td><td>{c.numero}</td><td>{c.alias ?? ''}</td><td>{c.tipo}</td>
          <td>Q {Number(c.saldoActual ?? 0).toFixed(2)}</td>
          <td><button onclick={() => cuentaSel = c.id!}>Ver</button></td>
        </tr>
      {:else}<tr><td colspan="6" class="empty">No hay cuentas registradas.</td></tr>{/each}
    </tbody>
  </table>

  {#if cuentaSel}
    <h3>Transacciones</h3>
    <form onsubmit={crearTx} class="row">
      <select bind:value={nuevaTx.tipo}>
        <option>DEPOSITO</option><option>RETIRO</option><option>NOTA_DEBITO</option><option>NOTA_CREDITO</option><option>TRANSFERENCIA</option><option>COMISION</option><option>INTERES</option>
      </select>
      <input type="number" step="0.01" placeholder="Monto" bind:value={nuevaTx.monto} required style="width:130px"/>
      <input placeholder="Referencia" bind:value={nuevaTx.referencia}/>
      <input placeholder="Concepto" bind:value={nuevaTx.concepto} style="flex:1;min-width:180px"/>
      <button type="submit">Registrar</button>
    </form>
    <table>
      <thead><tr><th>Fecha</th><th>Tipo</th><th>Monto</th><th>Concepto</th><th>Conciliada</th><th></th></tr></thead>
      <tbody>
        {#each transacciones as t (t.id)}
          <tr><td>{t.fecha?.slice(0,10) ?? ''}</td><td>{t.tipo}</td><td>Q {Number(t.monto).toFixed(2)}</td><td>{t.concepto ?? ''}</td><td>{t.conciliada ? 'Sí' : ''}</td><td>{#if !t.conciliada}<button onclick={() => conciliar(t.id!)}>Conciliar</button>{/if}</td></tr>
        {:else}<tr><td colspan="6" class="empty">Sin transacciones.</td></tr>{/each}
      </tbody>
    </table>

    <h3>Cheques</h3>
    <form onsubmit={emitirCheque} class="row">
      <input placeholder="Número" bind:value={nuevoChq.numero} required/>
      <input placeholder="Beneficiario" bind:value={nuevoChq.beneficiario} required style="flex:1;min-width:180px"/>
      <input type="number" step="0.01" placeholder="Monto" bind:value={nuevoChq.monto} required style="width:130px"/>
      <input placeholder="Concepto" bind:value={nuevoChq.concepto}/>
      <button type="submit">Emitir</button>
    </form>
    <table>
      <thead><tr><th>Número</th><th>Beneficiario</th><th>Monto</th><th>Estado</th><th></th></tr></thead>
      <tbody>
        {#each cheques.filter(c=>c.cuentaId===cuentaSel) as c (c.id)}
          <tr><td>{c.numero}</td><td>{c.beneficiario}</td><td>Q {Number(c.monto).toFixed(2)}</td><td>{c.estado}</td>
          <td>{#if c.estado === 'EMITIDO' || c.estado === 'ENTREGADO'}<button onclick={() => cobrarCh(c.id!)}>Marcar cobrado</button>{/if}</td></tr>
        {:else}<tr><td colspan="5" class="empty">Sin cheques en esta cuenta.</td></tr>{/each}
      </tbody>
    </table>
  {/if}
</section>

<style>
  header { display:flex; justify-content:space-between; align-items:center }
  .row { display:flex; gap:.5rem; flex-wrap:wrap; margin:1rem 0; align-items:center }
  .row input, .row select, .row button { padding:.45rem .6rem; border-radius:8px; border:1px solid #ccc; font:inherit }
  .row button { background:#0d6efd; color:#fff; border:0; cursor:pointer }
  table { width:100%; border-collapse:collapse; margin-bottom:1rem }
  th, td { padding:.5rem .6rem; border-bottom:1px solid #eee; text-align:left; font-size:.9rem }
  tr.sel { background:#e7f0ff }
  .err { color:#b00020 } .empty { color:#888; text-align:center; font-style:italic }
  h3 { margin-top:1.5rem }
  td button { padding:.2rem .5rem; font-size:.8rem; border-radius:6px; border:1px solid #ccc; background:#fff; cursor:pointer }
</style>
